import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
} from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { toObservable } from '@angular/core/rxjs-interop';
import { Carousel } from 'primeng/carousel';
import { combineLatest, map, Observable, switchMap } from 'rxjs';
import { Guid } from '@web/utils';
import {
  ImageThumbnailComponent,
  SpinnerFilledComponent,
} from '@web/shared/ui';
import { AdminBrandBannerPreviewItem } from '../../models/admin-brand-banner-preview-item';
import { AdminBrandBannerDataSourceService } from '../../services/admin-brand-banner-data-source.service';

@Component({
  selector: 'app-admin-brand-banner-preview',
  imports: [
    Carousel,
    CommonModule,
    ImageThumbnailComponent,
    NgOptimizedImage,
    SpinnerFilledComponent,
  ],
  templateUrl: './admin-brand-banner-preview.component.html',
  styleUrl: './admin-brand-banner-preview.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdminBrandBannerPreviewComponent {
  private readonly bannerDataSource = inject(AdminBrandBannerDataSourceService);

  public readonly brandId = input.required<Guid>();
  public readonly reloadVersion = input(0);

  protected readonly brandId$ = toObservable(this.brandId);
  protected readonly reloadVersion$ = toObservable(this.reloadVersion);
  protected readonly banners$ = this.bannersSource();

  protected isMoreThanOne(banners: AdminBrandBannerPreviewItem[]): boolean {
    return banners.length > 1;
  }

  private bannersSource(): Observable<AdminBrandBannerPreviewItem[]> {
    return combineLatest([this.brandId$, this.reloadVersion$]).pipe(
      map(([brandId]) => brandId),
      switchMap((brandId) =>
        this.bannerDataSource.fetchPreviewCollection({
          brandId,
        }),
      ),
    );
  }
}
